import React, { useEffect } from 'react';
import styled from 'styled-components';
import CenterLolumnLayout from '../../layout/screen';
import './style.scss';
import { Link, useLocation } from 'react-router-dom';
import PageFooter from '../../components/page-footer';
import { getLoginRoute, getMapRoute } from '../../routes';
import { useResetBackground } from '../../layout/background';


const IntroScreen = styled.main``

export default function IntroPage() {

    const resetBackground = useResetBackground();
    useEffect(() => {
        resetBackground();
    }, [resetBackground])

    useEffect(() => {
        document.body.classList.add('rules-page');

        return () => {
            document.body.classList.remove('rules-page');
        }
    })

    const { state } = useLocation<{ fromMap: boolean }>();

    const showGoToMap = state ? state.fromMap : false;
    const showGoToLogin = !showGoToMap;

    return (
        <CenterLolumnLayout footer={PageFooter()}>
            <IntroScreen className='rules-screen column'>
                <h1>Zasady gry</h1>

                <ol>
                    <li>Gra składa się z 10 zadań dostępnych na mapie. Możesz je rozwiązywać w dowolnej kolejności.</li>                    
                    <li>Zadania są oznaczone kolorami i przypisane do określonych miejsc na mapie. Aby rozpocząć zadanie, kliknij w kolorowy punkt na mapie.</li>
                    <li>Ukończenie zadania potwierdź, klikając w przycisk „Zakończ zadanie”.</li>
                    <li>Aby wrócić do instrukcji, kliknij na mapie w przycisk: „Instrukcja”.</li>
                    <li>Przed rozpoczęciem gry, na kolejnej stronie wpisz swoje imię/pseudonim lub nazwę drużyny.</li>      
                    <li>Powodzenia! </li>
                </ol>

                {showGoToLogin && <Link to={getLoginRoute()} className="button-big"><span>Dalej</span></Link>}
                {showGoToMap && <Link to={getMapRoute()} className="button-big"><span>Rozwiń mapę</span></Link>}
            </IntroScreen>
        </CenterLolumnLayout >
    )
}
